import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import {  MatListModule } from '@angular/material/list';
import {  MatMenuModule } from '@angular/material/menu';
import {  MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import {  MatTabsModule } from '@angular/material/tabs';
import {  MatChipsModule } from '@angular/material/chips';
import {  MatInputModule } from '@angular/material/input';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {  MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {  MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import {  MatRadioModule } from '@angular/material/radio';
import {  MatProgressBarModule } from '@angular/material/progress-bar';
import {  MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';


@NgModule({
  imports: [
    // material
    MatTabsModule,
    MatChipsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatDialogModule,
    MatSliderModule,
    MatProgressBarModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatExpansionModule
  ],
  declarations: [],
  exports: [
    // material
    MatTabsModule,
    MatChipsModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatDividerModule,
    MatDialogModule,
    MatProgressBarModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatExpansionModule
  ]
})
export class MaterialModule {
}
